var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-view',{attrs:{"headers":_vm.headers,"row-actions":_vm.rowActions,"top-actions":_vm.topActions,"url":_vm.consentTypeUrl,"title":_vm.consentTypeName,"enable-filters":false,"enable-search":false},scopedSlots:_vm._u([{key:"item.siteId",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$t(!!item.siteId ? 'No' : 'Yes')))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }